








// vendor
import { defineComponent, computed, ref } from "@vue/composition-api";
// project
import * as Info from "@/info";

export default defineComponent({
	setup(){
		const displayVersion = computed(() => {
			const [
				tId,
				tMisc
			] = (Info.BuildInfo["TAG"] || "").split("-");
			if(!tId){ return "-"; }
			return `v${tId}${ tMisc ? '-dev' : ''}`;
		});

		return {
			displayVersion,
		};
	}
});

